import { useState } from 'react';
import './style.css';

const InputTags = ({ prompt, options, record, onUpdate }) => {
  // Parser
  let init = [];
  if (typeof record != 'string') {}
  else if (record) {
    init = record.split(/[, ]+/).sort();
    console.log(init);
  }
  const [tags, setTags] = useState(init);

  // Autocomplete
  const [ableOptions, setAbleOptions] = useState([]);

  // Add tags
  function handleAdd(option) {
    // Check for blank and repetition
    if (option.trim().length === 0) {};
    if (tags.some((tag) => tag.toLowerCase() === option.trim().toLowerCase())) {};
    // Check for default values
    let id = options.findIndex((opt) => opt.toLowerCase() === option.toLowerCase());
    let temp = [];
    let newOption = '';
    if (id < 0) newOption = option;
    else newOption = options[id];
    temp = [...tags, newOption].sort();
    setTags(temp);
    onUpdate(temp.join(', '));
    // Remove in search result
    setAbleOptions(ableOptions.filter((opt) => opt != newOption));
  }
  // Remove tags
  function handleClose(index) {
    let temp = tags[index];
    setTags(tags.filter((tag) => tag != temp));
    onUpdate(tags.filter((tag) => tag != temp).join(', '));
    // Add to search result
    if (options.includes(temp)) setAbleOptions([...ableOptions, temp].sort());
  }

  const handleSearch = (e) => {
    if (e.target.value.length === 0) setAbleOptions([]);
    else {
      let newOptions = options.filter((option) =>
        option.toLowerCase().includes(e.target.value.toLowerCase())
      );
      newOptions = newOptions.filter((option) => !tags.includes(option));
      setAbleOptions(newOptions.sort());
    }
  };

  return (
    <div className="container">
      <div className="tagsContainer">
        {tags.map((tags, index) => (
          <div className="tagItem">
            <div className="text">{tags}</div>
            <div className="close" onClick={() => handleClose(index)}>
              &times;
            </div>
          </div>
        ))}
        {tags.length < 25 && (
          <div className="searchMenu">
            <input
              type="text"
              className="tagsInput"
              placeholder={prompt}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  handleAdd(e.target.value);
                  e.target.value = '';
                }
              }}
              maxLength="25"
              onChange={handleSearch}
            />
          </div>
        )}
        {ableOptions.map((opt, idx) => {
          return (
            <ul className="list">
              <button
                key={idx}
                type="button"
                className="listItems"
                onClick={() => {
                  handleAdd(opt);
                  setAbleOptions(ableOptions.filter((option) => option != opt));
                }}
              >
                {opt}
              </button>
            </ul>
          );
        })}
      </div>
    </div>
  );
};

export default InputTags;
